var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6663 2.16675H1.33301C1.05967 2.16675 0.833008 1.94008 0.833008 1.66675C0.833008 1.39341 1.05967 1.16675 1.33301 1.16675H14.6663C14.9397 1.16675 15.1663 1.39341 15.1663 1.66675C15.1663 1.94008 14.9397 2.16675 14.6663 2.16675Z",
    fill: "url(#paint0_linear_1718_21542)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.44629 1.66675V9.64675C2.44629 10.3001 2.75296 10.9201 3.27962 11.3134L6.75296 13.9134C7.49296 14.4667 8.51296 14.4667 9.25296 13.9134L12.7263 11.3134C13.253 10.9201 13.5596 10.3001 13.5596 9.64675V1.66675H2.44629ZM10.6663 9.16675H5.33296C5.05962 9.16675 4.83296 8.94008 4.83296 8.66675C4.83296 8.39341 5.05962 8.16675 5.33296 8.16675H10.6663C10.9396 8.16675 11.1663 8.39341 11.1663 8.66675C11.1663 8.94008 10.9396 9.16675 10.6663 9.16675ZM10.6663 5.83342H5.33296C5.05962 5.83342 4.83296 5.60675 4.83296 5.33341C4.83296 5.06008 5.05962 4.83341 5.33296 4.83341H10.6663C10.9396 4.83341 11.1663 5.06008 11.1663 5.33341C11.1663 5.60675 10.9396 5.83342 10.6663 5.83342Z",
    fill: "url(#paint1_linear_1718_21542)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1718_21542",
    x1: 0.884198,
    y1: 1.66672,
    x2: 15.1441,
    y2: 1.07025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#431DAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE6DFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1718_21542",
    x1: 2.48598,
    y1: 7.99717,
    x2: 13.5617,
    y2: 7.9688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#431DAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE6DFE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBill);
export default __webpack_public_path__ + "static/media/bill.26fc4ce6dc1e512ae984b9adb691744e.svg";
export { ForwardRef as ReactComponent };